<template>
  <div>
    <p>Made by <a href="https://github.com/Alan-Liang/">Alan Liang</a></p>
    <p>Source code available on <a href="https://github.com/Alan-Liang/GGJ22">GitHub</a></p>
  </div>
</template>
